import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "full-width" }

import { useRoute } from "vue-router";
import { computed } from "vue";
import { onboardingStore, permissionStore, sessionApiStore } from "@/hooks";
import { Routes } from "@/router";
import { FlexBox, Separator } from "@/components/common";
import { ProjectSearchbar } from "@/components/search";
import TextButton from "@/components/common/button/TextButton.vue";
import Icon from "@/components/common/display/icon/Icon.vue";
import MembersBar from "./MembersBar.vue";
import NavBreadcrumbs from "./NavBreadcrumbs.vue";


/**
 * Renders the top navigation bar header.
 */
const __default__ = {
  name: "HeaderBar",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const currentRoute = useRoute();

const graphVisible = computed(() => currentRoute.path === Routes.ARTIFACT);

return (_ctx: any,_cache: any) => {
  const _component_q_space = _resolveComponent("q-space")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(FlexBox), {
      "full-width": "",
      justify: "between",
      align: "center",
      y: "1"
    }, {
      default: _withCtx(() => [
        (_unref(permissionStore).isDemo)
          ? (_openBlock(), _createBlock(Icon, {
              key: 0,
              variant: "safa",
              class: "q-mr-md"
            }))
          : _createCommentVNode("", true),
        _createVNode(NavBreadcrumbs),
        _createVNode(MembersBar),
        _createVNode(_component_q_space),
        (graphVisible.value && !_unref(permissionStore).isDemo)
          ? (_openBlock(), _createBlock(_unref(ProjectSearchbar), { key: 1 }))
          : _createCommentVNode("", true),
        (_unref(permissionStore).isDemo)
          ? (_openBlock(), _createBlock(TextButton, {
              key: 2,
              text: "",
              color: "primary",
              class: "q-ml-md",
              icon: "calendar",
              label: "Contact Us",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(onboardingStore).handleScheduleCall(false)))
            }))
          : _createCommentVNode("", true),
        (_unref(permissionStore).isDemo)
          ? (_openBlock(), _createBlock(TextButton, {
              key: 3,
              text: "",
              color: "gradient",
              class: "q-ml-md bd-gradient",
              icon: "member-add",
              label: "Sign Up",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(sessionApiStore).handleLogout(true, true)))
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    (graphVisible.value)
      ? (_openBlock(), _createBlock(_unref(Separator), {
          key: 0,
          nav: ""
        }))
      : _createCommentVNode("", true)
  ]))
}
}

})